export const siteConfig = {
  brand: {
    name: 'Let Lois',
    logoWhite:
      'https://cdn.magicpatterns.com/uploads/mn4CmUa5nwdD8HGkwwtFqd/LetLois_Logo_White.png',
  },
  contact: {
    phone: '(555) 123-4567',
    email: 'hello@letlois.com',
  },
  links: {
    privacy: 'https://letlois.com/privacy-policy',
    terms: 'https://letlois.com/terms-of-use',
  },
  form: {
    webhookUrl:
      'https://services.leadconnectorhq.com/hooks/WgeUwGrMjGHUoyOlMkdT/webhook-trigger/57a04cee-1446-4db3-8829-70ea7b66d73f',
    turnstileSiteKey: '1x00000000000000000000AA', // Testing key
    adSpendOptions: ['Less than $5K', '$5K to $10K', '$10K to $25K', '$25K+'],
  },
  hero: {
    eyebrow: 'FOR MED SPA OWNERS SPENDING $5K+ PER MONTH ON ADS',
    headline: 'Stop Guessing Which Ads Actually Book Appointments.',
    subheadline:
      'Watch how the top performing med spas track every lead from click to booked treatment, then get our team to set it up for you inside Go High Level.',
    bullets: [
      'Track exactly which ads drive booked appointments, not just leads',
      'Hit a 20 to 24 percent lead-to-show rate consistently',
      'Feed winning data back to Meta and Google to scale profitable campaigns',
    ],
    trustLine:
      'Trusted by med spas across the US to build their full lead-to-revenue tracking systems.',
  },
  video: {
    eyebrow: 'WATCH THE FULL BREAKDOWN',
    headline: 'How Top Med Spas Are Tracking Every Dollar of Ad Spend in 2026.',
    subtext:
      'The Let Lois co-founders walk through the exact attribution system, conversion math, and Go High Level workflow you need to scale past 40 booked appointments per month.',
    youtubeId: 'dQw4w9WgXcQ', // Placeholder
    caption:
      'Runtime approximately 7 minutes. Prefer to skip the video? Book a call below and we will walk you through it live.',
  },
  stats: {
    eyebrow: 'WHAT GOOD LOOKS LIKE',
    headline: 'The Conversion Math Every Med Spa Owner Should Know.',
    subtext:
      "If you are spending real money on ads, here is what your numbers should look like. If they don't, your tracking or your funnel is broken.",
    cards: [
      { stat: '$20K', label: 'Healthy lead volume at $20K monthly spend' },
      { stat: '40', label: 'From 250 leads at a 16 percent book rate' },
      { stat: '20-24%', label: 'The minimum bar for a healthy med spa funnel' },
      { stat: '3:1', label: '10:1 means it is time to scale ad spend hard' },
    ],
  },
  problem: {
    eyebrow: 'THE REAL PROBLEM',
    headline: 'Most Med Spas Have No Idea Which Ads Actually Make Them Money.',
    paragraphs: [
      'You see leads coming in. You see some appointments getting booked. But you cannot tell which platform, which campaign, or which ad is actually driving real revenue. So you keep all of them running, hoping the math works out.',
      'Initial revenue from a new client usually just covers the cost of acquiring them. The real profit comes from nurturing them across multiple bookings and treatments over a 12 month window. If you are not tracking that full lifetime value, you are flying blind on how much you can actually afford to spend.',
      'We fix this by building a closed loop attribution system inside Go High Level. Every lead is tagged with its true source. Every booked appointment is fed back to Meta and Google. Winning ads scale. Losing ads die.',
    ],
    image:
      'https://cdn.magicpatterns.com/uploads/gyVoX77tc2GZ96BZygq2BL/med-spa-landing-page.jpg',
  },
  process: {
    eyebrow: 'OUR PROCESS',
    headline: 'How We Set This Up Inside Go High Level.',
    subtext:
      'This is the exact system we walk through on the strategy call. We can build it for you, or hand you the playbook to do it yourself.',
    steps: [
      {
        title: 'Workflow Setup',
        desc: "We build a 'Contact Created' workflow inside your Go High Level account that automatically captures the true attribution source of every new lead.",
      },
      {
        title: 'Source Segmentation',
        desc: 'The workflow splits leads by session source so paid social, paid search, organic, and referral all flow into clean reporting buckets you can actually trust.',
      },
      {
        title: 'Booked Appointment Feedback',
        desc: 'When a lead becomes a booked appointment or a paid customer, that data flows back into your reporting and back to the ad platforms so you know which ads make money.',
      },
      {
        title: 'Optimization Loop',
        desc: 'Meta and Google use that conversion data to find more leads that look like your best customers. Winning ads scale. Wasted budget gets cut.',
      },
    ],
  },
  fit: {
    forYou: [
      'You are spending at least $5K per month on Meta or Google Ads for your med spa',
      'You can see leads coming in but cannot confidently say which ad is driving booked appointments',
      'You want to scale ad spend but are nervous about pouring money into something you cannot measure',
    ],
    notForYou: [
      'You have not started running paid ads yet (start there first, then come back)',
      'You are not willing to invest at least $5K per month into ad spend',
      'You want a magic bullet without doing the implementation work',
    ],
  },
  founders: {
    eyebrow: 'WHO WE ARE',
    headline:
      'The Let Lois Team Has Built These Systems For Med Spas Across the Country.',
    body: 'We run Let Lois, a digital marketing and Go High Level implementation agency based in Gilbert, Arizona. We have built custom websites, ad campaigns, and full attribution systems for med spas, clinics, and service businesses generating millions in tracked revenue. We are not coaches. We actually build the systems.',
    team: [
      {
        name: 'Josh',
        title: 'Co-Founder of Let Lois',
        image:
          'https://cdn.magicpatterns.com/uploads/gjQCJMsQnNVGso44DpMTaB/josh-profile.jpg',
      },
      {
        name: 'Noah',
        title: 'Co-Founder of Let Lois',
        image:
          'https://cdn.magicpatterns.com/uploads/jV1t54dAbyXDxQ9sfZAwbN/noah-profile.jpg',
      },
    ],
  },
  cta: {
    headline: 'Ready to Know Exactly Which Ads Are Making You Money?',
    subtext:
      'Book a free 20 minute strategy call. We will look at your current ad accounts and Go High Level setup and show you exactly what to fix. No pressure, no pitch deck.',
  },
}
